export default __webpack_public_path__ + "static/media/xpf-home.95f98b80.jpg";